import { defineComponent as _defineComponent } from 'vue'
import { appLink } from '@@/bits/app_link'
import { dir } from '@@/bits/current_dir'
import device from '@@/bits/device'
import { isAppUsing } from '@@/bits/flip'
import { navigateTo } from '@@/bits/location'
import { isRegistered } from '@@/bits/user_model'
import { defineAsyncComponent } from '@@/bits/vue'
import { checkIfUserIsInZoomCollaborateMode } from '@@/bits/zoom'
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from '@@/library/v4/components/OzContainedButton.vue'
import OzPadletLogo, {
  OzPadletLogoColorScheme,
  OzPadletLogoSizePreset,
} from '@@/library/v4/components/OzPadletLogo.vue'
import { useSurfaceStore } from '@@/pinia/surface'
import { useSurfaceGuestStore } from '@@/pinia/surface_guest_store'
import { useSurfaceOnboardingDemoPadletPanelStore } from '@@/pinia/surface_onboarding_demo_padlet_panel_store'
import SurfaceActivityIndicator from '@@/vuecomponents/SurfaceActivityIndicator.vue'
import SurfaceHeaderMobile from '@@/vuecomponents/SurfaceHeaderMobile.vue'
import SurfacePadletLogoInScreenshotMode from '@@/vuecomponents/SurfacePadletLogoInScreenshotMode.vue'
import SurfaceTitle from '@@/vuecomponents/SurfaceTitle.vue'
import { storeToRefs } from 'pinia'
import { computed, nextTick, onMounted, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceHeader',
  setup(__props, { expose }) {

const SurfaceNav = defineAsyncComponent(() => import('@@/vuecomponents/SurfaceNav.vue'))
const SurfaceSearchBar = defineAsyncComponent(() => import('@@/vuecomponents/SurfaceSearchBar.vue'))
const SurfaceTitleOld = defineAsyncComponent(() => import('@@/vuecomponents/surface_title.vue'))

const surfaceStore = useSurfaceStore()
const {
  xHeader,
  isEmbedded,
  searchBarTop,
  isWhiteboard,
  isMap,
  backgroundColor,
  headerColor,
  backgroundLuminance,
  colorScheme,
  homeUrl,
  hasSidePanelOutsideSurface,
  isReadOnly,
  isSubmissionRequest,
  isDesktopLayout,
  isMobileLayout,
  isUserHostingZoomCollaboration,
  user,
  skinPrimaryVariantColorAsRGB,
  isSkinColorAvailable,
  isNativeTenant,
  isScreenshotMode,
} = storeToRefs(surfaceStore)

const { demoPadletPanelVisibility, isDemoPadletPanelDesktop } = storeToRefs(useSurfaceOnboardingDemoPadletPanelStore())

const surfaceGuestStore = useSurfaceGuestStore()

const amIRegistered = computed(() => user.value.registered)
const hasDarkBackgroundLuminance = computed(() => {
  if (isMap.value) {
    return colorScheme.value !== 'light'
  }

  return backgroundLuminance.value !== 'light'
})
const realBackgroundLuminance = computed(() => {
  if (isMap.value) {
    return colorScheme.value
  }
  return backgroundLuminance.value
})

const isUserRegistered = computed(() => {
  return isRegistered(user.value)
})

// Obfuscate the app link
function openAppLink() {
  navigateTo(appLink)
}
/**
 * ZOOM
 */
const isUserInZoomCollaborationMode = ref(false)
const isZoomCollaborationGuest = computed(
  () => isUserInZoomCollaborationMode.value === true && isUserHostingZoomCollaboration.value === false,
)
onMounted(async () => {
  // Don't prompt for notifications if the user is not registered and the app is not the electron app
  if (amIRegistered.value && !device.electronApp) {
    surfaceStore.checkAndSubscribeToPushNotifications()
  }

  isUserInZoomCollaborationMode.value = await checkIfUserIsInZoomCollaborateMode()
})

const updateHeaderHeight = () => {
  if (isDesktopLayout.value) {
    nextTick(() => {
      const headerEl = surfaceHeader.value
      if (!headerEl) return
      surfaceStore.resizeHeader({ height: headerEl.getBoundingClientRect().height })
    })
  }
}

const surfaceHeaderMobile = ref<InstanceType<typeof SurfaceHeaderMobile>>()
const collapse = (): void => {
  if (!surfaceHeaderMobile.value) return
  surfaceHeaderMobile.value.collapse()
}

const surfaceHeaderDesktop = ref<HTMLDivElement>()
const surfaceHeaderEmbedded = ref<HTMLDivElement>()
const surfaceHeader = computed(
  () =>
    (surfaceHeaderMobile.value?.$el || surfaceHeaderDesktop.value || surfaceHeaderEmbedded.value) as
      | HTMLElement
      | undefined,
)

watch(
  surfaceHeader,
  () => {
    updateHeaderHeight()
  },
  { immediate: true },
)

expose({
  collapse,
})

return { __sfc: true,SurfaceNav, SurfaceSearchBar, SurfaceTitleOld, surfaceStore, xHeader, isEmbedded, searchBarTop, isWhiteboard, isMap, backgroundColor, headerColor, backgroundLuminance, colorScheme, homeUrl, hasSidePanelOutsideSurface, isReadOnly, isSubmissionRequest, isDesktopLayout, isMobileLayout, isUserHostingZoomCollaboration, user, skinPrimaryVariantColorAsRGB, isSkinColorAvailable, isNativeTenant, isScreenshotMode, demoPadletPanelVisibility, isDemoPadletPanelDesktop, surfaceGuestStore, amIRegistered, hasDarkBackgroundLuminance, realBackgroundLuminance, isUserRegistered, openAppLink, isUserInZoomCollaborationMode, isZoomCollaborationGuest, updateHeaderHeight, surfaceHeaderMobile, collapse, surfaceHeaderDesktop, surfaceHeaderEmbedded, surfaceHeader, dir, device, isAppUsing, OzContainedButton, OzContainedButtonColorScheme, OzContainedButtonSizePreset, OzPadletLogo, OzPadletLogoColorScheme, OzPadletLogoSizePreset, SurfaceActivityIndicator, SurfaceHeaderMobile, SurfacePadletLogoInScreenshotMode, SurfaceTitle }
}

})